import React, { useEffect, useState } from 'react';
import '../CSS/Global.css'; // Ensure your CSS file path is correct
import { useNavigate, useParams } from 'react-router-dom';
import productadd from "../Images/productadd.png"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { v4 as uuid } from "uuid";

const EditProject = () => {
    const [productName, setProductName] = useState('');
    const [mrp, setMrp] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [image, setImage] = useState();
    const login = JSON.parse(localStorage.getItem("login")) || "";
    let navigate = useNavigate();
    const { id } = useParams();
    const [selectedUnit, setSelectedUnit] = useState('');
    const [quantity, setSelectedQuantity] = useState('');
    const [units, setUnits] = useState([]);
    const [castList, setCastList] = useState([]);
    const url = process.env.REACT_APP_URL
    const [showAdditional, setShowAdditional] = useState(false);
    const [credits, setCredits] = useState(0);
    const [showCastSection, setShowCastSection] = useState(false);
    const [dateLaunched, setDateLaunched] = useState('');
    const quillRef = React.useRef(null);

    console.log(id);

    const handleImageUpload = (event) => {
        const file = event.target.files[0]; // Get the first file from input
        setImage(file); // Store the selected image in state
    };


    const handleDescriptionChange = (value) => {
        const editor = quillRef.current?.getEditor();
        if (!editor) return;  // prevent null errors

        const plain = editor.getText().trim();

        if (plain.length > 1000) {
            editor.deleteText(1000, plain.length); // THIS WORKS NOW
            return;
        }

        setShortDescription(value);
    };

    // Add form submission logic here

    const fetchDataProduct = async () => {
        try {
            const response = await fetch(`${url}/product/getsingleproduct/${id}`);
            const res = await response.json();
            console.log(res);

            setProductName(res.product_name);
            setSellingPrice(res.sell_price);
            setMrp(res.mrp_price);
            setShortDescription(res.description);
            setImage(res.product_image);
            setSelectedQuantity(res.quantity);
            setSelectedUnit(res.unit);
            setDateLaunched(res.datelaunched)
            const parsedCast = res.castlist ? JSON.parse(res.castlist) : [];
            setCastList(parsedCast);

            // --- Important ---
            setCredits(parsedCast.length);   // show number in dropdown
            setShowAdditional(true);         // open additional section
            setShowCastSection(true);        // show cast form

        } catch (error) {
            console.log(error);
        }
    };



    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('product_image', image);
        formData.append('product_name', productName);
        formData.append('mrp_price', mrp);
        formData.append('sell_price', sellingPrice);
        formData.append('quantity', quantity);
        formData.append('unit', selectedUnit);
        formData.append('description', shortDescription);
        formData.append('user_id', login.permanent_ID);
        formData.append('user_name', login.name);
        formData.append('datelaunched', dateLaunched);
        formData.append('castlist', JSON.stringify(castList));
        formData.append('type', 'portfolio');

        try {
            // Replace with your backend API URL
            const response = await fetch(`${url}/product/change-product/${id}`, {
                method: 'PUT',
                body: formData,
            });

            const result = await response.json();
            console.log('Image uploaded:', result);
            if (response.ok) {
                navigate(-1)
            }
        } catch (error) {
            console.log('Error uploading image:', error);
        }
        console.log({
            productName,
            mrp,
            sellingPrice,
            shortDescription,
        });
    };

    useEffect(() => {
        fetchDataProduct();
    }, [])

    return (
        <div className="product-container">
            <div className="product-image-column">
                <img
                    src={productadd}
                    alt="Product"
                    className="product-image"
                />
            </div>
            <div className="product-form-column">
                <h2>List Your Product/Skills/Service</h2>
                <form onSubmit={handleSubmit}>
                    <div className="product-form-group">
                        <label>Title:</label>
                        <input
                            type="text"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            placeholder="Enter Title"
                            required
                        />
                    </div>
                    <div className="product-form-group">
                        <label>Upload Image:</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}

                        />
                        <div>
                            <img className='imageeditproductmain' src={`${url}/${image}`} />
                        </div>
                    </div>
                    <div className="product-form-group">
                        <label>Date Launched:</label>
                        <input
                            type="date"
                            value={dateLaunched}
                            onChange={(e) => setDateLaunched(e.target.value)}
                            required
                        />
                    </div>

                    <div className="product-form-group">
                        <label>Description (max 1000 chars):</label>
                        <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            value={shortDescription}
                            onChange={handleDescriptionChange}
                            placeholder="Description"
                            style={{ height: "120px" }}
                        />
                    </div>
                    <div className="product-form-group" style={{ marginTop: "50px" }}>
                        <label style={{ fontWeight: "600" }}>Additional Details</label>
                        <div
                            onClick={() => setShowAdditional(!showAdditional)}
                            className="toggle-btn"
                            style={{
                                width: "60px",
                                height: "30px",
                                background: showAdditional ? "var(--red)" : "#ccc",
                                borderRadius: "20px",
                                cursor: "pointer",
                                position: "relative",
                                transition: "0.3s",
                                marginBottom: "10px"
                            }}
                        >
                            <div
                                style={{
                                    width: "26px",
                                    height: "26px",
                                    background: "#fff",
                                    borderRadius: "50%",
                                    position: "absolute",
                                    top: "2px",
                                    left: showAdditional ? "32px" : "2px",
                                    transition: "0.3s"
                                }}
                            ></div>
                        </div>
                    </div>
                    {showAdditional && (
                        <div className="lfproject-additional-box">

                            {/* Credits Dropdown */}
                            <div className="lfproject-credit-box">
                                <label>Add Credits:</label>

                                <select
                                    className="lfproject-credit-select"
                                    value={credits}
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        setCredits(value);

                                        if (value > castList.length) {
                                            const extra = Array.from({ length: value - castList.length }, () => ({
                                                id: uuid(),
                                                name: "",
                                                character: ""
                                            }));
                                            setCastList([...castList, ...extra]);
                                        } else {
                                            setCastList(castList.slice(0, value));
                                        }

                                        setShowCastSection(true);
                                    }}
                                >

                                    <option value={0}>Select Credits</option>
                                    {[10, 20, 30, 40, 50, 60, 70, 80, 90].map((c) => (
                                        <option key={c} value={c}>
                                            Add {c} Credits
                                        </option>
                                    ))}
                                </select>

                            </div>

                            {/* Cast Section */}
                            {showCastSection && (
                                <div className="lfproject-credits-wrapper">

                                    <h2 className="lfproject-title">Cast and Crew</h2>
                                    {/* <h3 className="lfproject-subtitle">Cast</h3> */}

                                    {castList.map((item, index) => (
                                        <div key={index} className="lfproject-cast-box">

                                            <div className="lfproject-cast-header">
                                                New #{index + 1}

                                                {/* DELETE BUTTON */}
                                                <button
                                                    type='button'
                                                    className="lfproject-delete-btn"
                                                    onClick={() => {
                                                        const updated = [...castList];
                                                        updated.splice(index, 1);
                                                        setCastList(updated);
                                                    }}>
                                                    <i class="fa-solid fa-xmark"></i>
                                                </button>
                                            </div>

                                            <div className='lfnew-divflesing'>
                                                <div className="lfproject-input-group">
                                                    <label>Name</label>
                                                    <input
                                                        type="text"
                                                        className="lfproject-text-input"
                                                        value={item.name}
                                                        onChange={(e) => {
                                                            const updated = [...castList];
                                                            updated[index].name = e.target.value;
                                                            setCastList(updated);
                                                        }}

                                                    />
                                                </div>

                                                <div className="lfproject-input-group">
                                                    <label>Role</label>
                                                    <input
                                                        type="text"
                                                        className="lfproject-text-input"
                                                        value={item.character}
                                                        onChange={(e) => {
                                                            const updated = [...castList];
                                                            updated[index].character = e.target.value;
                                                            setCastList(updated);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    ))}

                                </div>
                            )}
                        </div>
                    )}
                    <button type="submit" className="product-submit-button">Edit Product</button>
                </form>
            </div>
        </div>
    );
};

export default EditProject;
